import { render } from "./StockQuantity.vue?vue&type=template&id=0333b32e"
import script from "./StockQuantity.vue?vue&type=script&lang=ts"
export * from "./StockQuantity.vue?vue&type=script&lang=ts"
script.render = render

export default script